// inbox-103 / roadmap A4 wire — клиент /me.
// Backend: GET /me, PATCH /me, PATCH /me/password, GET /me/orgs (inbox-138).

import { req } from './client';

export type Role = 'owner' | 'admin' | 'manager' | 'viewer';
export type Plan = 'free' | 'starter' | 'business' | 'team' | 'enterprise';
// inbox-268 — staff_role независим от tenant role.
// 'none' (default обычный user, console недоступна),
// 'support' (read-only console), 'admin' (impersonate), 'superadmin'
// (feature_flags + менять staff_role).
export type StaffRole = 'none' | 'support' | 'admin' | 'superadmin';

// inbox-274 — контекст активной имперсонации, non-null только если staff
// сейчас работает «под» юзером (backend inbox-267 + inbox-301).
export interface ImpersonationContext {
  imp_session_id: number;
  impersonator_id: number;
  target_user_id: number;
  /** ISO timestamp начала сессии. */
  started_at: string;
  /** ISO timestamp когда session протухнет (TTL ~30 мин). */
  expires_at: string;
  /** Указанная staff'ом причина (audit-trail). */
  reason: string;
}

export interface Me {
  id: number;
  email: string;
  name: string;
  role: Role;
  organization_id: number;
  organization_name: string;
  organization_plan: Plan;
  email_confirmed: boolean;
  two_factor_enabled: boolean;
  /** inbox-274 — non-null только во время активной имперсонации. */
  impersonation?: ImpersonationContext | null;
  /** inbox-268 — staff-роль для console-доступа.
   * Backend MeOut пока не отдаёт это поле (TODO @vps-backend);
   * guard трактует undefined как 'none' (deny by default). */
  staff_role?: StaffRole;
  /** inbox-257 — индивидуальный per-user тариф (User.plan, inbox-260).
   * Отделён от organization_plan. Backend MeOut TODO @vps-backend.
   * UI использует для gating фич (QR-кастомизатор Pro-фичи, и т.п.).
   * Fallback на organization_plan если поле undefined. */
  user_plan?: Plan;
}

export interface MePatch {
  name?: string;
}

/** inbox-138 — элемент org-switcher dropdown'а. */
export interface Org {
  id: number;
  name: string;
  slug: string;
  plan: Plan;
  role: Role;
  is_current: boolean;
}

export const MeApi = {
  get(): Promise<Me> {
    return req<Me>('/me');
  },
  patch(body: MePatch): Promise<Me> {
    return req<Me>('/me', { method: 'PATCH', body: JSON.stringify(body) });
  },
  /** inbox-138 — список org'ов пользователя для org-switcher dropdown. */
  getOrgs(): Promise<Org[]> {
    return req<Org[]>('/me/orgs');
  },
};
